export const currencyFormat = (value: any) => {
  if (value) return `R$${parseFloat(value).toFixed(2)}`.replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
  return value;
};

export const currencyFormatSemAbreviacao = (value: any) => {
  if (value) return `${parseFloat(value).toFixed(2)}`.replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
  return value;
};

export const currencyFormatReal = (valor: string) => {
  var tmp = valor + '';
  tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
  if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

  return tmp;
};

export const currencyParser = (value: any) => {
  const n = (Number(`${value}`.replace(/[^0-9]+/g, '')) / 100).toFixed(2);
  if (parseFloat(n) > 0) return n;
  return '';
};

export const numberFormat = (value: any) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const numberParser = (value: any) => {
  const n = Number(`${value}`.replace(/[^0-9]+/g, ''));
  if (n > 0) return n;
  return '';
};

export const formatReal = (valor: string) => {
  let tmp = valor + '';
  tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
  tmp = tmp.replace('.,', ',');
  if (tmp.length > 6) {
    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');
  }
  return tmp;
};



export const handleParser = (number: string) => {
  let valor = number.replace(/[^0-9]/g, "");
  let valorFloat = parseFloat(valor) / 100;
  if (isNaN(valorFloat)) return '0,00';
  return valorFloat.toFixed(2);
};

export const thousandSeparator = (x) => {
  let values = x.split('.');
  let integers = values[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  if (values[1] == undefined) return integers + ',00';
  if (values[1].lenght === 1) return integers + (values[1] ? ',' + values[1] : '0');
  return integers + (values[1] ? ',' + values[1] : '');
};

export const formatCurrencyBr = (atual: number) => {
  if (atual == undefined)
    atual = 0;
  return atual.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}

export const formatCurrencyBrReturnNull = (atual: number) => {
  if (atual == undefined)
    return ''
  let converted = atual.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  if (converted === '-R$ 0,00') return 'R$ 0,00'
  return converted
}

export const formatCurrencyUS = (atual: number) => {
  if (atual == undefined)
    atual = 0;
  return atual.toLocaleString('pt-br', { style: 'currency', currency: 'USD' });
}


export const formatDateTimeBr = (data: Date) => {
  if (data == undefined)
    return '';
  return data.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

export const transformFloat = (value: string): number => {
  if (value == undefined)
    return 0;
  return parseFloat(value.replace(',', '.'));
}